import { useContext } from 'react';
import { LayoutContext } from './LayoutProvider';

/**
 * Access to the shell's layout state. Both the layout classes and the theme are
 * held by one provider — they share a single persisted blob, so splitting them
 * across two independent states would mean two writers racing to overwrite each
 * other's half of `layoutSettings`.
 */
export function useLayout() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used inside <LayoutProvider>.');
  }
  return context;
}

/**
 * Theme-only view of the same context, for components that switch colour mode
 * or palette and have no interest in navigation state.
 */
export function useTheme() {
  const { colorMode, toggleColorMode, themeStyle, setThemeStyle } = useLayout();
  return { colorMode, toggleColorMode, themeStyle, setThemeStyle };
}
